import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import FormGroup from '@material-ui/core/FormGroup';
import SaveIcon from '@material-ui/icons/Save';


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

//****************************************************************carregar tipos veiculo***************** */

     
      //****************************controle atalho cadastrar***************************** */
   
  

 
  var tipo='null';
  var novo=false;
export default function RecipeReviewCard(props) {

//*******************************salvar edit************ */

const handlesalvar=()=>{
    
  
 
 
  var userid;
  itemcatmotora.forEach(modelo=>(userid=modelo.id));
 
      var user = firebase.firestore().collection("categoriasmotorista").doc(userid);
  
      return user.update({valorhora50: hora50, valorhora100: hora100, valorespera: espera, valorsobreaviso: sobreaviso,
        valoradicionalnoturno: adicionalnoturno ,valoralmoco: almoco, valorjanta: janta,
         valorcafe: cafe, valorbanho: banho, valorpernoite:pernoite,
         valorhora50faturado: hora50faturado, valorhora100faturado: hora100faturado, valoresperafaturado: esperafaturado, valorsobreavisofaturado: sobreavisofaturado,
        valoradicionalnoturnofaturado: adicionalnoturnofaturado ,valoralmocofaturado: almocofaturado, valorjantafaturado: jantafaturado,
         valorcafefaturado: cafefaturado, valorbanhofaturado: banhofaturado, valorpernoitefaturado:pernoitefaturado
        })
          .then(function () {
                 
                  setedita(true);
                  setbotaoedit(false);
                  setExpanded(false);
      
                  
                  
                 
                   
              }).catch(function (error) {
                    var errorMessage = error.message;
          
                  alert(errorMessage);
                  })
    
    
    }

 




//********************objeto veiculo******************* */

const [itemcatmotora, setaitemcatmotora] = React.useState([]);
const [stid, setastid] = React.useState('');
const [pernoite, setapernoite] = React.useState('');
const [hora50, setahora50] = React.useState('');
const [hora100, setahora100] = React.useState('');
const [sobreaviso, setasobreaviso] = React.useState('');
const [espera, setaespera] = React.useState('');
const [adicionalnoturno, setaadicionalnoturno] = React.useState('');
const [almoco, setaalmoco] = React.useState('');
const [janta, setajanta] = React.useState('');
const [cafe, setacafe] = React.useState('');
const [banho, setabanho] = React.useState('');
const [catm, setacatm] = React.useState('');
//const [stid, setastid] = React.useState('');
const [pernoitefaturado, setapernoitefaturado] = React.useState('');
const [hora50faturado, setahora50faturado] = React.useState('');
const [hora100faturado, setahora100faturado] = React.useState('');
const [sobreavisofaturado, setasobreavisofaturado] = React.useState('');
const [esperafaturado, setaesperafaturado] = React.useState('');
const [adicionalnoturnofaturado, setaadicionalnoturnofaturado] = React.useState('');
const [almocofaturado, setaalmocofaturado] = React.useState('');
const [jantafaturado, setajantafaturado] = React.useState('');
const [cafefaturado, setacafefaturado] = React.useState('');
const [banhofaturado, setabanhofaturado] = React.useState('');


var tipo1='';
React.useEffect(() => {
    
setaitemcatmotora(props.props);

},[0]);

React.useEffect(() => {
    
  var ct;
  itemcatmotora.forEach(item=>{ct=item.catmotorista});
      setacatm(ct);
  var sid;
  itemcatmotora.forEach(item=>{sid=item.id});
      setastid(sid);
      var pern;
  itemcatmotora.forEach(item=>{pern=item.valorpernoite});
      setapernoite(pern);
      var h;
  itemcatmotora.forEach(item=>{h=item.valorhora50});
      setahora50(h);
      var h1;
  itemcatmotora.forEach(item=>{h1=item.valorhora100});
      setahora100(h1);
      var es;
  itemcatmotora.forEach(item=>{es=item.valorespera});
      setaespera(es);
      var sb;
  itemcatmotora.forEach(item=>{sb=item.valorsobreaviso});
      setasobreaviso(sb);
      var an;
  itemcatmotora.forEach(item=>{an=item.valoradicionalnoturno});
      setaadicionalnoturno(an);
      var al;
  itemcatmotora.forEach(item=>{al=item.valoralmoco});
      setaalmoco(al);
      var jan;
  itemcatmotora.forEach(item=>{jan=item.valorjanta});
      setajanta(jan);
      var cf;
  itemcatmotora.forEach(item=>{cf=item.valorcafe});
      setacafe(cf);
      var bn;
  itemcatmotora.forEach(item=>{bn=item.valorbanho});
      setabanho(bn);

      //********** */
      var pernfaturado;
  itemcatmotora.forEach(item=>{pernfaturado=item.valorpernoitefaturado});
      setapernoitefaturado(pernfaturado);
      var hfaturado;
  itemcatmotora.forEach(item=>{hfaturado=item.valorhora50faturado});
      setahora50faturado(hfaturado);
      var h1faturado;
  itemcatmotora.forEach(item=>{h1faturado=item.valorhora100faturado});
      setahora100faturado(h1faturado);
      var esfaturado;
  itemcatmotora.forEach(item=>{esfaturado=item.valoresperafaturado});
      setaesperafaturado(esfaturado);
      var sbfaturado;
  itemcatmotora.forEach(item=>{sbfaturado=item.valorsobreavisofaturado});
      setasobreavisofaturado(sbfaturado);
      var anfaturado;
  itemcatmotora.forEach(item=>{anfaturado=item.valoradicionalnoturnofaturado});
      setaadicionalnoturnofaturado(anfaturado);
      var alfaturado;
  itemcatmotora.forEach(item=>{alfaturado=item.valoralmocofaturado});
      setaalmocofaturado(alfaturado);
      var janfaturado;
  itemcatmotora.forEach(item=>{janfaturado=item.valorjantafaturado});
      setajantafaturado(janfaturado);
      var cffaturado;
  itemcatmotora.forEach(item=>{cffaturado=item.valorcafefaturado});
      setacafefaturado(cffaturado);
      

      var bnfaturado;
  itemcatmotora.forEach(item=>{bnfaturado=item.valorbanhofaturado});
      setabanhofaturado(bnfaturado);
  
  },[itemcatmotora]);
  





     

  //**************************controle habilita e desabilita */

  const [edita, setedita] = React.useState(true);
  const [botaoedit, setbotaoedit] = React.useState(false);

  const handleeditar=()=>{
    setedita(false);
    setbotaoedit(true);
    setExpanded(true);
    
  }



     //************************************controle card*/
     
         
     
     
       const classes = useStyles();
       const [expanded, setExpanded] = React.useState(false);
     
       const handleExpandClick = () => {
         setExpanded(!expanded);
         if(expanded){
         setedita(true);
         setbotaoedit(false)}
       };
     
       return (
         <Card className={classes.root} >
                <CardHeader
                  avatar={
                    
                    <Avatar aria-label="Veículo" className={classes.avatar}>
                     <FolderSharedIcon />
                    </Avatar>
                  }
                 
                  title= {catm}
                  //subheader= {itemmotora.map(modelo=>(modelo.matricula))}
          
                />
                
               
                 <CardActions disableSpacing>
                
                       
                  <IconButton id="btsalvar" aria-label="Salvar" disabled={edita} onClick={handlesalvar}>
                    <SaveIcon />
                  </IconButton>
                  <IconButton id="bteditar" aria-label="Editar" disabled={botaoedit} onClick={handleeditar}>
                    <CreateIcon />
                  </IconButton>
                  <IconButton
                    className={clsx(classes.expand, {
                      [classes.expandOpen]: expanded,
                    })}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="Visualizar"
                  >
                    <ExpandMoreIcon />
                  </IconButton>
          
                  
          
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                  <CardContent>
                  <form className={classes.form} onSubmit={handlesalvar} noValidate={false}>
                  
                                                
               <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setahora50(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="hora50"
                   label="Valor Pago hora extra 50% R$"
                   name="hora50"
                   defaultValue={hora50}
                   disabled={edita}
                   
                 />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setahora50faturado(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="hora50"
                   label="Valor Faturado hora extra  50% R$"
                   name="hora50"
                   defaultValue={hora50faturado}
                   disabled={edita}
                   
                 />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setahora100(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="hora100"
                   label="Valor Pago hora extra 100% R$"
                   name="hora"
                   defaultValue={hora100}
                   disabled={edita}
                   
                 />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setahora100faturado(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="hora100"
                   label="Valor Faturado hora extra 100% R$"
                   name="hora"
                   defaultValue={hora100faturado}
                   disabled={edita}
                   
                 />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setaadicionalnoturno(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="adicionalnoturno"
                   label="Valor Pago adicional noturno R$"
                   name="adicionalnoturno"
                   defaultValue={adicionalnoturno}
                   disabled={edita}
                   
                 />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setaadicionalnoturnofaturado(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="adicionalnoturno"
                   label="Valor Faturado adicional noturno R$"
                   name="adicionalnoturno"
                   defaultValue={adicionalnoturnofaturado}
                   disabled={edita}
                   
                 />
          
          
                          <TextField
                           
                           variant="outlined"
                           margin="normal"
                           onChange={ e=>setaalmoco(e.target.value)}
                           required
                           //type="phoneNumber"
                           fullWidth
                           id="almoco"
                           label="Valor Pago almoço R$"
                           name="almoço"
                           defaultValue={almoco}
                           disabled={edita}
                           
                           />   

<TextField
                           
                           variant="outlined"
                           margin="normal"
                           onChange={ e=>setaalmocofaturado(e.target.value)}
                           required
                           //type="phoneNumber"
                           fullWidth
                           id="almoco"
                           label="Valor Faturado almoço R$"
                           name="almoço"
                           defaultValue={almocofaturado}
                           disabled={edita}
                           
                           />   
                     
                     <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setajanta(e.target.value)}
                   required
                   type=""
                   fullWidth
                   id="janta"
                   label="Valor Pago jantar R$"
                   name="cnh"
                   defaultValue={janta}
                   disabled={edita}
                   
                   
                 />      

                 <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setajantafaturado(e.target.value)}
                   required
                   type=""
                   fullWidth
                   id="janta"
                   label="Valor Faturado jantar R$"
                   name="cnh"
                   defaultValue={jantafaturado}
                   disabled={edita}
                   
                   
                 />        
     
                 
                   
                   
                   <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setacafe(e.target.value)}
                   required
                   type="nu"
                   fullWidth
                   id="cafe"
                   label="Valor Pago café R$"
                   name="cafe"
                   defaultValue = {cafe}
                   disabled={edita}
                  />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setacafefaturado(e.target.value)}
                   required
                   type="nu"
                   fullWidth
                   id="cafe"
                   label="Valor Faturado café R$"
                   name="cafe"
                   defaultValue = {cafefaturado}
                   disabled={edita}
                  />

                  <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setaespera(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="espera"
                   label="Valor Pago espera R$"
                   name="espera"
                   defaultValue = {espera}
                   disabled={edita}
                  />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setaesperafaturado(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="espera"
                   label="Valor Faturado espera R$"
                   name="espera"
                   defaultValue = {esperafaturado}
                   disabled={edita}
                  />

                  <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setasobreaviso(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="sobreaviso"
                   label="Valor Pago sobre-aviso R$"
                   name="cafe"
                   defaultValue = {sobreaviso}
                   disabled={edita}
                  />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setasobreavisofaturado(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="sobreaviso"
                   label="Valor Faturado sobre-aviso R$"
                   name="cafe"
                   defaultValue = {sobreavisofaturado}
                   disabled={edita}
                  />
     
     <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setapernoite(e.target.value)}
                   required
                   type="nu"
                   fullWidth
                   id="pernoite"
                   label="Valor Pago Pernoite R$"
                   name="catcnh"
                   defaultValue = {pernoite}
                   disabled={edita}
                   />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setapernoitefaturado(e.target.value)}
                   required
                   type="nu"
                   fullWidth
                   id="pernoite"
                   label="Valor Faturado Pernoite R$"
                   name="catcnh"
                   defaultValue = {pernoitefaturado}
                   disabled={edita}
                   />
                   
                  <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setabanho(e.target.value)}
                   required
                   type="nu"
                   fullWidth
                   id="banho"
                   label="Valor Pago Banho R$"
                   name="banho"
                   defaultValue = {banho}
                   disabled={edita}
                   />

<TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setabanhofaturado(e.target.value)}
                   required
                   type="nu"
                   fullWidth
                   id="banho"
                   label="Valor Faturado Banho R$"
                   name="banho"
                   defaultValue = {banhofaturado}
                   disabled={edita}
                   />
                   
                  
                       
                     
                     
                      
          
                  <Typography >
                * Preenchimento obrigatório 
               </Typography>
          
               
             
                                  
               </form>
          
                  </CardContent>
                  <CardActions disableSpacing>
                
                 
          
                  <IconButton id="btsalvar" aria-label="Salvar" disabled={edita} onClick={handlesalvar}>
                    <SaveIcon />
                  </IconButton>
                  <IconButton id="bteditar" aria-label="Editar" disabled={botaoedit} onClick={handleeditar}>
                    <CreateIcon />
                  </IconButton>
                  <IconButton
                    className={clsx(classes.expand, {
                      [classes.expandOpen]: expanded,
                    })}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="Visualizar"
                  >
                    <ExpandMoreIcon />
                  </IconButton>
          
                  
          
                </CardActions>
                </Collapse>
              </Card>
       );
     }
 